import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import ImageUploading from "react-images-uploading";
import { useEditorImagesMutation } from "api/editorImages";
import { useEffect } from "react";

const Fotograflar = (props) => {
  const {
    onClose,
    open,
    articleId,
    images,
    setImagesState,
    imagesState,
    setImages,
    onChangeImages,
    token,
    setToken,
    ...other
  } = props;
  const style = { "& .MuiDialog-paper": { width: "100%" } };

  const handleCancel = () => {
    onClose();
  };

  const [EditorImages, imagesData] = useEditorImagesMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    EditorImages({ image: imagesState, articleId: articleId, token: token });
  };

  useEffect(() => {
    if (imagesData.isSuccess) {
      if (imagesData.data.uploadedImage) {
        setToken(imagesData.data.token);
        setImages(imagesData.data.uploadedImage);
        const imagesStateArray = imagesData.data.uploadedImage.map((row, i) => {
          return {
            id: row.id,
            data_url: "",
            deleted: false,
          };
        });

        setImagesState(imagesStateArray);
      }
    }
  }, [imagesData, setImagesState, setImages, setToken]);

  return (
    <Mui.Dialog sx={style} maxWidth="md" open={open} {...other}>
      <Mui.DialogTitle>Fotoğraflar</Mui.DialogTitle>
      <Mui.Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 1 }}
      >
        <Mui.DialogContent dividers>
          {imagesData.isLoading ? (
            <div className="w-full flex justify-center my-2 rounded-lg border border-gray-300">
              <h4 className="font-semibold py-2 text-xl text-black text-opacity-60">
                Yükeniyor...
              </h4>
            </div>
          ) : (
            <ImageUploading
              multiple={true}
              value={images}
              onChange={onChangeImages}
              dataURLKey="data_url"
              acceptType={["jpg", "png", "webp", "jpeg", "webp"]}
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                <div className="w-full block">
                  <div className="w-full grid grid-cols-3 gap-4">
                    <Mui.Button
                      size="small"
                      startIcon={<MuiIcons.AddPhotoAlternate />}
                      variant="contained"
                      color="info"
                      sx={{ color: isDragging ? "red" : null }}
                      onClick={onImageUpload}
                      {...dragProps}
                      lang="tr"
                      fullWidth
                    >
                      Fotoğraf Ekle
                    </Mui.Button>
                    <Mui.Button
                      size="small"
                      startIcon={<MuiIcons.RemoveCircle />}
                      variant="contained"
                      color="error"
                      onClick={onImageRemoveAll}
                      lang="tr"
                      fullWidth
                      disabled={images.length > 0 ? false : true}
                    >
                      Tüm Fotografları Kaldır
                    </Mui.Button>
                    <Mui.Button
                      size="small"
                      startIcon={<MuiIcons.Save />}
                      variant="contained"
                      color="success"
                      lang="tr"
                      fullWidth
                      onClick={handleSubmit}
                    >
                      İşlemi Kaydet
                    </Mui.Button>
                  </div>
                  <div className="uploaded-images-area">
                    <ul>
                      {imageList.map((image, i) => (
                        <li key={i}>
                          <div className="image">
                            <img src={image.data_url} alt="" />
                          </div>
                          <div className="actions-buttons">
                            <div className="btn-bottom">
                              <button
                                className="remove-photo"
                                type="button"
                                onClick={() => onImageRemove(i)}
                              >
                                Kaldır
                              </button>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </ImageUploading>
          )}
        </Mui.DialogContent>
      </Mui.Box>
      <Mui.DialogActions>
        <Mui.Button
          sx={{ mr: 1 }}
          startIcon={<MuiIcons.Cancel />}
          variant="contained"
          size="small"
          color="error"
          autoFocus
          onClick={handleCancel}
        >
          Kapat
        </Mui.Button>
        <Mui.Button
          endIcon={<MuiIcons.CheckCircle />}
          variant="contained"
          size="small"
          color="success"
          onClick={() => onClose(true)}
        >
          Kaydet
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default Fotograflar;
